import React from 'react';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Overview() {
  const classes = useStyles();
  const preventDefault = event => event.preventDefault();
  return (
    <div className={classes.root}>
      <div className="wraper">

        <Grid spacing={4} container direction="row" justify="center">
          <Grid item xs={12} md={8}>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                会社案内
              </Typography>
              <div className="text-left">
                　１９４５年１２月、デーリー東北新聞社は戦後の荒廃の中から力強く産声を上げた新聞社です。青森県を縦半分に割った太平洋側（青森県南地方）と岩手県北をエリアとする日刊紙「デーリー東北」を発行しています。県境をまたぐこの一帯は旧南部藩の領地だったところで「北奥羽」と言われていますが、特に、本社を置く八戸市内では、新聞購読世帯の８割以上にご愛読いただくなど、地域の根強い〝ファン〟に支えられています。<br />
                　創刊以来、北奥羽地域に根差した新聞ならではの視点で地域コミュニティーの〝接着剤〟となり「地域と人」をつないできました。<br />
                　その原点とも言える決意を新たにするため、２０１７年には「地域とともに宣言」を打ち出し、地域の皆さまとともに未来へ進むことをあらためて誓いました。<br />
                　新聞は人と人、人と社会をつなぎ、権力の監視役としても大きな役割を担っています。私たちは、デジタル化や人口減少社会など時代の変化に対応しながらも、地域のライフラインの一翼を担っている－という自負を胸に、確かな取材に裏付けられた正しい情報を、着実に家庭や職場に届けてきました。<br />
                　２０２１年にはスマートフォン専用アプリを導入し、より早く、皆さまのもとへ情報をお伝えすることができるようになりました。<br />
                　また、皆さまのライフスタイルを豊かにするお手伝いをしたいという思いから、紙の新聞に加え、デジタル、さらには文化、スポーツイベント、暮らしに役立つ事業などをトータルで提供し、この地域で暮らしていくためのプラットフォーム（基盤）の一つになりたいと考えています。<br />
                　変わらぬ想いで、変わり続けるデーリー東北。私たちはこれからも皆さまに寄り添い、読者に信頼されるメディアであり続けます。<br />
              </div>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                地域とともに宣言
              </Typography>
              <div className="text-center font-noto-m mt-4">
                <div class="d-inline-block text-left fs120 line180 font-weight-bold">
                  地域の皆さまに　愛され<br />
                  地域の皆さまの　心をつなぎ<br />
                  地域とともに　　未来へ進む<br />
                  <div className="text-right fs90 mt-3">
                    デーリー東北新聞社
                  </div>
                </div>
              </div>
              {/*
              <div className="text-left">
                　1945年12月、デーリー東北は戦後の荒廃の中から力強く産声を上げました。以来、「自由と正義と民主主義」をジャーナリズムの旗印に、北奥羽地域に住む人たちの豊かな生活のため、地域に寄り添い、地域に愛されながら、「地域づくりのパートナー」として歩んでまいりました。いま、時代の空気はそのころとよく似ています。混沌とした時代に、私たちが地域のために何ができるかを考えながら、私たちならではの新たな価値を生み出し、地域の皆さまとともに未来に向けて歩み続けます。
              </div>
              */}
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                デーリー東北の理念
              </Typography>
              <dl>
                <dt>・自由と正義と民主主義の精神で</dt>
                <dd>
                  言論、報道を通じ、常に誠実で物事の真実に迫る努力を重ね、健全な新聞ジャーナリズムのさらなる発展にまい進します。
                </dd>
                <dt>・新たな価値の創造へ</dt>
                <dd>
                  地域の皆さまとの信頼関係を礎に、常に変革と創造に挑戦し、独自性に富んだ新たな企業価値を生み出します。
                </dd>
                <dt>・北奥羽を豊かに</dt>
                <dd>
                  自らの公共的使命を自覚し、地域の皆さまの期待に応え、手を携えて北奥羽地域の豊かな郷土づくりに貢献します。
                </dd>
              </dl>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                私たちが大切にするもの
              </Typography>
              <dl>
                <dt>・未来に挑戦</dt>
                <dd>
                  私たちは前例のない難しい時代と向き合っています。だからといって、リスクや失敗を恐れていては前には進めません。常にチャレンジャーであり続け、新たな未来に挑戦します。
                </dd>
                <dt>・本物の価値</dt>
                <dd>
                  今ほど本物が求められる時代はありません。私たちは常に新しいものを取り入れる意欲的な姿勢と深い洞察力を持ち、地域の皆さまが真に求める本物の価値を追求します。
                </dd>
                <dt>・地域の絆</dt>
                <dd>
                  世界で社会の分断が表面化しています。私たちは、地域やそこに暮らす人々のつながりを一番大事にします。地域の皆さまの心をつなぐ絆となり、地域とともに前進します。
                </dd>
                <dt>・多様性の力</dt>
                <dd>
                  私たちは多様性の持つ力を信じます。それぞれの個性や価値観を尊重し、一人ひとりが成長できる魅力的で楽しい、活力あふれる企業を目指します。
                </dd>
              </dl>
            </Box>

            <Box my={8}>
              <Box my={8}>
                <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                  会社概要
                </Typography>
                {/*
                <div className="text-left">
                　日本新聞協会加盟の新聞社の多くが創刊から１００年以上の歴史を刻んできているなかにあって、「デーリー東北」は昭和２０年１２月に創刊された生粋の戦後生まれの新聞です。朝刊単独紙で本社所在地は青森県の東南部、太平洋に面した八戸市。<br/>
                　昭和２０年８月の敗戦。軍国主義から民主主義の世の中へ。新聞界もそれまでの「１県１紙」戦時体制打破の動きが活発化し、全国に無数の新聞が産声をあげました。「デーリー東北」もそのなかの１紙でしたが、ゆっくりながら着実に地域での地歩を固め、今日に至っています。<br/>
                　青森県というと、「津軽」を思い浮かべがちですが、東側半分は旧南部藩の領地だったところで、津軽地方とは言葉、気質とも大分違います。「デーリー東北」は、この東側半分と岩手県北部の県境地域をエリアとしていて、いわゆる“県紙”とは違った持ち味を売り物にしています。<br/>
                　当社では、地域に根ざした新聞作りのため取材網の整備と充実を図ってきました。現在、青森支社はじめ十和田、三沢、むつなど県内に9支社総局、お隣岩手県盛岡、久慈、二戸市に3支局、仙台支社、東京支社、大阪支社の計15支社総局を構え地域に密着した取材・営業活動を続けています。<br/>
                　また平成20(2008)年7月には、本社隣接地に新印刷工場が完成、最新鋭のカラートップ・オフセット輪転機が稼働、最大16個面のカラーページが印刷可能となりました。併せてＣＴＰ(自動製版機)も導入、デジタル化でより一層鮮明になった紙面を読者に届けています。さらに高齢化社会に対応すべく基本文字を拡大、目に優しく一段と読みやすくなったと好評を得るなど、常に技術革新を続けています。<br/>
                </div>
                */}
              </Box>
              <Box my={8}>
                <Paper className="fs90">
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>社　名</Grid>
                    <Grid item xs={12} md={8}>株式会社デーリー東北新聞社</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>所在地</Grid>
                    <Grid item xs={12} md={8}>青森県八戸市城下一丁目３－１２</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>創　刊</Grid>
                    <Grid item xs={12} md={8}>１９４５年（昭和２０年）１２月</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>代表取締役社長</Grid>
                    <Grid item xs={12} md={8}>広瀬　知明</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>資本金</Grid>
                    <Grid item xs={12} md={8}>７，０００万円</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>発行部数</Grid>
                    <Grid item xs={12} md={8}>約８７，０００部</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>発行形態</Grid>
                    <Grid item xs={12} md={8}>朝刊単独紙</Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>購読料</Grid>
                    <Grid item xs={12} md={8}>
                      １カ月３，３００円<br />
                    </Grid>
                  </Grid>
                  <Divider variant="middle" />
                  <Grid className="p-3" spacing={0} container direction="row" justify="center">
                    <Grid item xs={12} md={4}>従業員数</Grid>
                    <Grid item xs={12} md={8}>１９６人</Grid>
                  </Grid>
                </Paper>
              </Box>
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={6}>
                    <CustomButton href="/planofaction" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      一般事業主行動計画
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                沿　革
              </Typography>
              <Box my={8}>
                <div className="contents-item">
                  <div className="table__wrapper">
                    <table className="table">
                      <tbody>
                        <tr>
                          <th className="enkaku-th" scope="row">1945</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>株式会社デーリー東北を創立（１０日）</li>
                                <li>平版印刷によるデーリー東北を発行（１５日）</li>
                                <li>全紙２ページ、月１０回発行</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1946</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日２ペ－ジ発行。共同通信社と受信契約</li>
                                <li>日本新聞協会に加盟</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1956</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日４ページ建てとする。</li>
                                <li>共同通信社の電送受信機設置</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1963</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日６ページ建てとする</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>11月</li>
                              </ul>
                              <ul>
                                <li>東京支社開設</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1964</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日１２ページ建てとする</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>デーリー東北政経懇話会創立</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1971</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>商号を株式会社デーリー東北新聞社と改める</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1972</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>1月</li>
                              </ul>
                              <ul>
                                <li>第１回デーリー東北賞贈呈式</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>折り込みチラシを扱うデーリー東北事業センター設立</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1973</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>7月</li>
                              </ul>
                              <ul>
                                <li>紙齢一万号記念「ホリディ・オン・アイス」八戸特別公演開く、日本ＡＢＣ協会加入</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1975</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>2月</li>
                              </ul>
                              <ul>
                                <li>政経懇話会上北地区例会発足</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1981</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>3月</li>
                              </ul>
                              <ul>
                                <li>ＣＴＳ全面移行</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>11月</li>
                              </ul>
                              <ul>
                                <li>新社屋完成。超高速度輪転機導入</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1982</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>7月</li>
                              </ul>
                              <ul>
                                <li>１行１３字に基本文字拡大</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1983</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>5月</li>
                              </ul>
                              <ul>
                                <li>うみねこマラソン全国大会主催</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1986</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日１４ページ建てとする</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1986</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日１４ページ建てとする</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1989</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>10月</li>
                              </ul>
                              <ul>
                                <li>オンラインＣＴＳ全面移行</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1991</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>10月</li>
                              </ul>
                              <ul>
                                <li>記事１６ページ建てとし、時事通信社とフューチャー契約</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1992</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>8月</li>
                              </ul>
                              <ul>
                                <li>オフセット・カラー輪転機印刷開始</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1994</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>1月</li>
                              </ul>
                              <ul>
                                <li>発行部数１０万部を達成</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>１行１２字に基本文字を拡大。毎日１８ページ建てとする</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1996</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>9月</li>
                              </ul>
                              <ul>
                                <li>創刊５０周年記念式典</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1997</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>毎日２０ページ建てとする</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>新・新聞製作システム（ＣＴＳIII）始動式・修祓式</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">1998</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>5月</li>
                              </ul>
                              <ul>
                                <li>別館・折込センター落成祝賀会</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>6月</li>
                              </ul>
                              <ul>
                                <li>タワー式カラー輪転機印刷開始</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2001</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>１行11字に基本文字拡大</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>5月</li>
                              </ul>
                              <ul>
                                <li>ホームページ運用開始</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>11月</li>
                              </ul>
                              <ul>
                                <li>紙齢２万号達成。記者パソコンシステム運用開始</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2005</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>7月</li>
                              </ul>
                              <ul>
                                <li>新CTSシステム・広告システム始動式・修祓式</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>9月</li>
                              </ul>
                              <ul>
                                <li>創刊６０周年記念パーティー</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>発行部数１１万部を達成</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2008</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>１行10字に基本文字拡大</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>7月</li>
                              </ul>
                              <ul>
                                <li>新印刷工場竣工、新オフセット輪転機(6200UD)稼働</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2015</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>デーリー東北ホール完成</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>8月</li>
                              </ul>
                              <ul>
                                <li>横組の新題字に変更、Ｅｃｏｎｏｍｉｃ　Ｍｏｎｄａｙ創刊</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2016</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>8月</li>
                              </ul>
                              <ul>
                                <li>本紙購読者向けサイト「デーリー東北デジタル」運用開始</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>11月</li>
                              </ul>
                              <ul>
                                <li>本社敷地内に「しんぶんカフェ　デーリー東北ホール×俵屋」をオープン</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2020</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>創刊75周年を記念して、エコノミックマンデー号外を発行</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2021</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>「デーリー東北デジタル」アプリ版の配信を開始</li>
                              </ul>
                            </div>
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>12月</li>
                              </ul>
                              <ul>
                                <li>「頑張るあなたを応援する　デリオン賞」創設</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2022</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>6月</li>
                              </ul>
                              <ul>
                                <li>まごころサポートを開始</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2024</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>4月</li>
                              </ul>
                              <ul>
                                <li>ふるさとホームｅｙｅとＨＩＢＩ＋を開始</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th className="enkaku-th" scope="row">2025</th>
                          <td className="enkaku-td">
                            <div className="enkaku__contents__wrapper d-flex align-items-center">
                              <ul>
                                <li>5月</li>
                              </ul>
                              <ul>
                                <li>種差海岸芝生地エリアに複合施設「ミチル種差」オープン</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Box>
            </Box>











            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                デーリー東北新聞社公式キャラクター「デリオン」
              </Typography>
              　単体では弱くできることは限られますが、みんなで力を合わせれば、地域の課題を解決できる新聞記者の姿をライオンに重ね、「デリオン」記者は誕生しました。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://event-guide.daily-tohoku.news/about-delion" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                デーリー東北賞、デーリー東北特別賞
              </Typography>
              　「デーリー東北賞」は、北奥羽地方に住んでいる方、またはその地方のご出身の方で、地方文化・産業・経済・学術・芸術・スポーツなどの各分野で卓越した功績のあった個人、団体をたたえるため、１９７１（昭和４６）年に創設しました。<br/>
              　２００８（平成２０）年には、その年に輝かしい業績をあげた北奥羽地方ゆかりの個人・団体を顕彰する、「デーリー東北特別賞」を制定しました。<br/>
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="/award" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                頑張るあなたを応援するデリオン賞
              </Typography>
              　北奥羽に住んでいる方で、地域貢献や将来期待される活動に取り組む人たちに幅広く光を当てエールを送るものです。<br />
              　デーリー東北賞５０周年を記念して２０２１年に創設しました。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="/award-delion" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                東北のデザイン社
              </Typography>
              　地域をより良くしたい思いを込めた新聞社生まれのデザイン会社です。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://www.tohokuno-design.com/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                デーリー東北たびーぐ
              </Typography>
              　デーリー東北新聞社１ＦにＪＴＢの窓口ができました。<br/>
              　ＪＴＢの豊富な商品の取り扱いや、独自のツアーも企画運営しています。<br/>
              　お電話での受付もしておりますのでお気軽にお問い合わせください。<br/>
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://stores.jtb.co.jp/bp289-0" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                南部会館
              </Typography>
              　八戸市文化教養センター「南部会館」の指定管理を受託しています。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://www.nanbukaikan.com/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                しんぶんカフェ
              </Typography>
              　デーリー東北ホールに新たなコミュニティー空間が生まれました。<br />
              　店舗はカフェコーナーとすし・和食コーナーがあります。
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/company-cafe.html" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      詳　細
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid className="fs80 line150" item md={4}>
            <Box my={8}>
              <Typography className="font-weight-bold my-3" variant="subtitle1" component="h6">
                本社、支社、総支局所在地
              </Typography>
              <dl>
              	<dt>本　　社</dt>
              	<dd>
                  {/*
                  〒０３１－８６０１<br/>青森県八戸市城下一丁目３－１２<br/>TEL (０１７８)４４－５１１１
                  */}
                  〒０３１－８６０１<br/>青森県八戸市城下一丁目３－１２<br/>
                  <ul className="list-style-none px-0">
                    <li className="my-3">
                      <div class="my-1 underline">紙面へのご意見、掲載写真のご注文</div>
                      <div className="font-weight-bold">▼読者センター</div>
                      TEL (０１７８)８０－７１０５<br/>
                      （9:30〜17:00 土日祝休み）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">新聞広告のお申し込み・広告料のお支払い</div>
                      <div className="font-weight-bold">▼地域ビジネス部・営業部門</div>
                      TEL (０１７８)８０－７０９５<br/>
                      （9:30〜17:00）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">主催イベントに関するお問い合わせ、デーリー東北ホールのお申し込み</div>
                      <div className="font-weight-bold">▼地域ビジネス部・事業部門</div>
                      TEL (０１７８)８０－７２９９<br/>
                      （9:30〜17:00 土日祝休み）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">取材に関するお問い合わせ</div>
                      <div className="font-weight-bold">▼報道部</div>
                      TEL (０１７８)８０－７０１７<br/>
                      （9:30〜23:00 土日祝は10:00〜）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">ひろば面（イベント情報掲載・こだま等）に関するお問い合わせ</div>
                      <div className="font-weight-bold">▼ひろば担当</div>
                      TEL (０１７８)８０－７１３８<br/>
                      （10:00〜19:00）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">文化面、ヤングポスト面、趣味・レジャー面に関するお問い合わせ</div>
                      <div className="font-weight-bold">▼文化部</div>
                      TEL (０１７８)８０－７１７３<br/>
                      （9:30〜19:00）
                    </li>
                    <li className="my-3">
                    <div class="my-1 underline">デーリー東北の書籍のご注文・お問い合わせ</div>
                      <div className="font-weight-bold">▼出版部</div>
                      TEL (０１７８)８０－７２０４<br/>
                      （9:30〜17:00 土日祝休み）
                    </li>
                    <li className="my-3">
                      <div class="my-1 underline">その他のお問い合わせ</div>
                      <div className="font-weight-bold">▼総務部</div>
                      TEL (０１７８)４４－５１１１<br/>
                      （9:30〜17:00 土日祝休み）
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl>
              	<dt>別館・折込センター</dt>
              	<dd>〒０３１－００７２<br/>青森県八戸市城下二丁目４－４<br/>TEL (０１７８)４６－３１９５</dd>
              </dl>
              <dl>
              	<dt>別館・まごころサポート事務局</dt>
              	<dd>〒０３１－００７２<br/>青森県八戸市城下二丁目４－４<br/>TEL (０１７８)７３－８０４０</dd>
              </dl>
              <dl>
              	<dt>青森支社</dt>
              	<dd>〒０３０－０８６１<br/>青森県青森市長島二丁目１０ー５　パークフロント青い森ビル３階<br/>TEL (０１７)７７７－５２５５</dd>
              </dl>
              <dl>
              	<dt>東京支社</dt>
              	<dd>〒１０４－００６１<br/>東京都中央区銀座七丁目１３－２１　銀座新六洲ビル７階<br/>TEL (０３)３５４３－０２４８</dd>
              </dl>
              <dl>
              	<dt>仙台支社</dt>
              	<dd>〒９８０－００１４<br/>宮城県仙台市青葉区本町１−１４−１８　ライオンズプラザ本町ビル６０４<br/>TEL (０２２)２１４－１５１５</dd>
              </dl>
              {/* 
              <dl>
              	<dt>大阪支社</dt>
              	<dd>〒５３０－０００１<br/>大阪府大阪市北区梅田一丁目１－３　大阪駅前第３ビル２５階<br/>TEL (０６)６３４４－１１４１</dd>
              </dl>
               */}
              <dl>
              	<dt>十和田総局</dt>
              	<dd>〒０３４－００９３<br/>青森県十和田市西十二番町３－７<br/>TEL (０１７６)２３－２４１８</dd>
              </dl>
              {/* 
              <dl>
              	<dt>十和田総局六戸分局</dt>
              	<dd>〒０３９－２３７１<br/>青森県上北郡六戸町犬落瀬若宮４－１<br/>TEL (０１７６)５５－４２７３</dd>
              </dl>
               */}
              {/* 
              <dl>
              	<dt>十和田総局七戸分局</dt>
              	<dd>〒０３４－００９３<br/>青森県十和田市西十二番町３－７<br/>TEL (０１７６)２３－２４１８</dd>
              </dl>
               */}
              <dl>
              	<dt>三沢総局</dt>
              	<dd>〒０３３－００３１<br/>青森県三沢市桜町二丁目１２－１１<br/>TEL (０１７６)５３－２４９５</dd>
              </dl>
              {/* 
              <dl>
              	<dt>三沢総局野辺地分局</dt>
              	<dd>〒０３９－３１６３<br/>青森県上北郡野辺地町新町裏１５－６<br/>TEL (０１７５)６４－３２１０</dd>
              </dl>
               */}
              <dl>
              	<dt>むつ総局</dt>
              	<dd>〒０３５－００７１<br/>青森県むつ市小川町二丁目２１－１７<br/>TEL (０１７５)２２－３６８３</dd>
              </dl>
              {/* 
              <dl>
              	<dt>六ケ所支局</dt>
              	<dd>〒０３９－３２１２<br/>青森県上北郡六ケ所村尾鮫野附４６４の５　パレスリョウⅢ　B号<br/>TEL (０１７５)７２－９０８０</dd>
              </dl>
              */}
              {/*
              <dl>
              	<dt>七戸支局</dt>
              	<dd>〒０３９－２５２６<br/>青森県上北郡七戸町上町野１２－１５<br/>TEL (０１７６)６２－５１６０</dd>
              </dl>
              */}
              <dl>
              	<dt>三戸支局</dt>
              	<dd>〒０３９－０１３５<br/>青森県三戸郡三戸町八日町７０<br/>TEL (０１７９)２２－１１３７</dd>
              </dl>
              <dl>
              	<dt>五戸支局</dt>
              	<dd>〒０３９－１５１８<br/>青森県三戸郡五戸町下モ沢向１３－１７６<br/>TEL (０１７８)６２－３３５０</dd>
              </dl>
              <dl>
              	<dt>盛岡支局</dt>
              	<dd>〒０２０―００１５<br/>岩手県盛岡市本町通二丁目８ー２０　ロイヤル仁王レジデンス８０２号<br/>TEL (０１９)６５３－５３６３</dd>
              </dl>
              <dl>
              	<dt>久慈支局</dt>
              	<dd>〒０２８－００５１<br/>岩手県久慈市川崎町１０－２９<br/>TEL (０１９４)５３－３４５６</dd>
              </dl>
              <dl>
              	<dt>二戸支局</dt>
              	<dd>〒０２８―６１０１<br/>岩手県二戸市福岡橋場１１ー３３　カネシメ橋場住宅５号<br/>TEL ０１９５(２３)２４２４</dd>
              </dl>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Overview;
